<template>
    <div class="card">
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-md-4">{{ $t('inventory_stock_out_loc_black_qty') }}</div>
                    <div class="col-md-4" style="color: red">{{ $t('inventory_stock_out_loc_red_qty') }}</div>
                    <div class="col-md-4" style="color: blue">{{ $t('inventory_stock_out_loc_blue_qty') }}</div>
                </div>
                <Multiselect
                    v-model="getLocation"
                    :options="locationList"
                    mode="single"
                    :can-clear=true
                    :searchable="true"
                    :placeholder="this.$t('inventory_search_location') + ' (' + this.locationList.length + ')'"
                    @select="itemSelected(1)"
                    @clear="itemSelected(0)"
                    style="margin: 3px;width: auto"
                />
            </div>
        </div>
    </div>
</template>

<script>
import Multiselect from "@vueform/multiselect";

export default {
    name: "StockCalculatedLocationBox",
    components: {
        Multiselect
    },
    props:{
        getTime: '',
        stockOutTempID: '',
        productID: '',
    },
    data(){
        return{
            getProductID: '',
            getLocation: '',
            locationList: [],
            locationDetailList: '',
            getStockOutTempID: null,
        }
    },
    methods: {
        async updateMode(returnData) {
            this.getProductID = returnData['pid']
            this.getStockOutTempID = returnData['sid']
            // activate backend data
            await this.getBackEndData(returnData['lid'])
            // activate as user clicked
            this.itemSelected(1)
        },
        clearData(){
            this.locationList = []
            this.getLocation = ''
        },
        async getBackEndData(getLocId){
            let stockOutTempCanUse = false
            if(this.stockOutTempID !== null && this.stockOutTempID !== ""){
                this.getStockOutTempID = this.stockOutTempID
                stockOutTempCanUse = true
            }
            if(this.getProductID){
                let url = `api/inventory/location?pid=${this.getProductID}`
                if(stockOutTempCanUse === true){
                    url += `&temp=${this.getStockOutTempID}`
                }
                await this.$mainApi.get(url)
                    .then(response => {
                        console.log(response.data)
                        if(response.data.status === 80){
                            this.locationList = []
                            this.getLocation = ''
                            let data = response.data.details
                            this.locationDetailList = response.data.details
                            for(let i=0;i<data.length;i++){
                                let nowCanUseQty = data[i]['qty'] - data[i]['stockOutTempQty2'] - data[i]['transTempQty2']
                                this.locationList.push({
                                    "label": data[i]['location'] + ' ' + data[i]['area'] + ': ' +
                                        '<strong>' + nowCanUseQty + '</strong>' +
                                        data[i]['stockOutTempQty'] + data[i]['transTempQty'] +
                                        '&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>' + this.$t('inventory_stock_out_total_qty') + data[i]['qty'] + '</i>',
                                    "value": data[i]['id'],
                                })
                            }
                        }
                    })
                if(Number.isInteger(getLocId)){
                    this.getLocation = getLocId
                }
            }else{
                // clear table data
                this.locationList = []
            }
        },
        itemSelected(flag){
            // 0 -> Clear, 1 -> selected
            if(flag === 0){
                this.getLocation = null
            }
            this.$emit('loc', this.getLocation === null ? null : this.locationDetailList.filter(a => a.id === this.getLocation)[0])
        }
    },
    watch: {
        'getTime': {
            async handler(newProductID) {
                this.getProductID = this.productID
                await this.getBackEndData()
            },
        }
    },
}
</script>

<style scoped>

</style>
